import { toast } from 'react-toastify';

import { AlertMessage } from './AlertMessage';

export const alert = (message: string) => {
  return toast<string>(<AlertMessage>{message}</AlertMessage>, {
    style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
  });
};

alert.success = (message: string) => {
  return toast<string>(
    <AlertMessage severity='success'>{message}</AlertMessage>,
    {
      style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
    },
  );
};

alert.info = (message: string) => {
  return toast<string>(<AlertMessage severity='info'>{message}</AlertMessage>, {
    style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
  });
};

alert.warning = (message: string) => {
  return toast<string>(
    <AlertMessage severity='warning'>{message}</AlertMessage>,
    {
      style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
    },
  );
};

alert.error = (message: string, dataTest?: string) => {
  return toast<string>(
    <AlertMessage severity='error' dataTest={dataTest}>{message}</AlertMessage>,
    {
      style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
    },
  );
};
